import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { buildDocumentTitle } from '../../utils/document-title.util';
import { AlertMessages } from '../AlertMessages';

interface Props {
  readonly reasons: readonly string[];
}

// Reached directly by its URL, a page the user may not use explains why instead of showing a form.
export const AccessDenied = ({ reasons }: Readonly<Props>) => (
  <>
    <Helmet>
      <title>{buildDocumentTitle('Accès refusé')}</title>
    </Helmet>
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography component="h1" sx={{ pb: 2 }} variant="h4">
        Accès refusé
      </Typography>
      <AlertMessages
        messages={reasons}
        severity="warning"
        sx={{ textAlign: 'left' }}
      />
      <Button
        component={Link}
        relative="path"
        sx={{ mt: 2 }}
        to=".."
        variant="contained"
      >
        Retour
      </Button>
    </Box>
  </>
);
